import { iconlyIcon } from "./iconly";
import { SpeakerHighIcon as PhosphorSpeakerHigh } from "@phosphor-icons/react/dist/csr/SpeakerHigh";
import { LightningIcon as PhosphorLightning } from "@phosphor-icons/react/dist/csr/Lightning";
import { CoinsIcon as PhosphorCoins } from "@phosphor-icons/react/dist/csr/Coins";
import { MusicNotesIcon as PhosphorMusic } from "@phosphor-icons/react/dist/csr/MusicNotes";
import { FloppyDiskIcon as PhosphorSave } from "@phosphor-icons/react/dist/csr/FloppyDisk";
import { EyedropperIcon as PhosphorEyedropper } from "@phosphor-icons/react/dist/csr/Eyedropper";
import { LinkIcon as PhosphorLink } from "@phosphor-icons/react/dist/csr/Link";
import { LockSimpleIcon as PhosphorLock } from "@phosphor-icons/react/dist/csr/LockSimple";
import { createElement, forwardRef } from "react";
import type { Icon, IconProps } from "@phosphor-icons/react/dist/lib/types";
import { MegaphoneIcon as PhosphorMegaphone } from "@phosphor-icons/react/dist/csr/Megaphone";
import { BooksIcon as PhosphorBooks } from "@phosphor-icons/react/dist/csr/Books";
import { PushPinIcon as PhosphorPin } from "@phosphor-icons/react/dist/csr/PushPin";
import { PaletteIcon as PhosphorPalette } from "@phosphor-icons/react/dist/csr/Palette";
import { MapPinIcon as PhosphorLocation } from "@phosphor-icons/react/dist/csr/MapPin";
import { ShapesIcon as PhosphorShapes } from "@phosphor-icons/react/dist/csr/Shapes";
import { ListIcon as PhosphorMenu } from "@phosphor-icons/react/dist/csr/List";
import { SidebarSimpleIcon as PhosphorPanelLeft } from "@phosphor-icons/react/dist/csr/SidebarSimple";
import { ArrowClockwiseIcon as PhosphorRefresh } from "@phosphor-icons/react/dist/csr/ArrowClockwise";
import { ArrowUUpLeftIcon as PhosphorUndo } from "@phosphor-icons/react/dist/csr/ArrowUUpLeft";
import { ArrowUUpRightIcon as PhosphorRedo } from "@phosphor-icons/react/dist/csr/ArrowUUpRight";
import { ArrowsOutIcon as PhosphorExpand } from "@phosphor-icons/react/dist/csr/ArrowsOut";
import { PlusIcon as PhosphorPlus } from "@phosphor-icons/react/dist/csr/Plus";
import { MinusIcon as PhosphorMinus } from "@phosphor-icons/react/dist/csr/Minus";
import { DownloadSimpleIcon as PhosphorDownload } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { UserIcon as PhosphorUser } from "@phosphor-icons/react/dist/csr/User";
import { WifiSlashIcon as PhosphorOffline } from "@phosphor-icons/react/dist/csr/WifiSlash";
import { SignOutIcon as PhosphorSignOut } from "@phosphor-icons/react/dist/csr/SignOut";
import { TrashIcon as PhosphorTrash } from "@phosphor-icons/react/dist/csr/Trash";
import { CheckIcon as PhosphorCheck } from "@phosphor-icons/react/dist/csr/Check";
import { CircleHalfIcon as PhosphorCircleHalf } from "@phosphor-icons/react/dist/csr/CircleHalf";
import { CircleNotchIcon as PhosphorCircleNotch } from "@phosphor-icons/react/dist/csr/CircleNotch";
import { CheckCircleIcon as PhosphorCheckCircle } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { XCircleIcon as PhosphorXCircle } from "@phosphor-icons/react/dist/csr/XCircle";
import { MagicWandIcon as PhosphorReusable } from "@phosphor-icons/react/dist/csr/MagicWand";
import { PulseIcon as PhosphorActivity } from "@phosphor-icons/react/dist/csr/Pulse";
import { UsersIcon as PhosphorTeam } from "@phosphor-icons/react/dist/csr/Users";
import { CaretDownIcon as PhosphorCaretDown } from "@phosphor-icons/react/dist/csr/CaretDown";
import { CaretUpIcon as PhosphorCaretUp } from "@phosphor-icons/react/dist/csr/CaretUp";
import { CaretLeftIcon as PhosphorCaretLeft } from "@phosphor-icons/react/dist/csr/CaretLeft";
import { CaretRightIcon as PhosphorCaretRight } from "@phosphor-icons/react/dist/csr/CaretRight";
import { CaretUpDownIcon as PhosphorCaretUpDown } from "@phosphor-icons/react/dist/csr/CaretUpDown";
import { DotsThreeIcon as PhosphorMore } from "@phosphor-icons/react/dist/csr/DotsThree";
import { DotsThreeVerticalIcon as PhosphorMoreVertical } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { XIcon as PhosphorClose } from "@phosphor-icons/react/dist/csr/X";
import { SlidersHorizontalIcon as PhosphorSliders } from "@phosphor-icons/react/dist/csr/SlidersHorizontal";
import { CreditCardIcon as PhosphorCreditCard } from "@phosphor-icons/react/dist/csr/CreditCard";
import { SquaresFourIcon as PhosphorWorkspaces } from "@phosphor-icons/react/dist/csr/SquaresFour";
import { WarningIcon as PhosphorWarning } from "@phosphor-icons/react/dist/csr/Warning";
import { GridFourIcon as PhosphorGrid } from "@phosphor-icons/react/dist/csr/GridFour";
import { ListDashesIcon as PhosphorList } from "@phosphor-icons/react/dist/csr/ListDashes";
import { TextAlignLeftIcon as PhosphorText } from "@phosphor-icons/react/dist/csr/TextAlignLeft";
import { SparkleIcon as PhosphorSparkle } from "@phosphor-icons/react/dist/csr/Sparkle";
import { HeartIcon as PhosphorHeart } from "@phosphor-icons/react/dist/csr/Heart";
import { ArrowUpIcon as PhosphorArrowUp } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { ArrowRightIcon as PhosphorArrowRight } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { CropIcon as PhosphorCrop } from "@phosphor-icons/react/dist/csr/Crop";
import { SunIcon as PhosphorSun } from "@phosphor-icons/react/dist/csr/Sun";
import { PlayIcon as PhosphorPlay } from "@phosphor-icons/react/dist/csr/Play";
import { PauseIcon as PhosphorPause } from "@phosphor-icons/react/dist/csr/Pause";
import { PaperclipIcon as PhosphorPaperclip } from "@phosphor-icons/react/dist/csr/Paperclip";
import { StackIcon as PhosphorStack } from "@phosphor-icons/react/dist/csr/Stack";
import { InfoIcon as PhosphorInfo } from "@phosphor-icons/react/dist/csr/Info";
import { QuestionIcon as PhosphorQuestion } from "@phosphor-icons/react/dist/csr/Question";
import { CopyIcon as PhosphorCopy } from "@phosphor-icons/react/dist/csr/Copy";
import { CubeIcon as PhosphorCube } from "@phosphor-icons/react/dist/csr/Cube";

/** Iconly Bold for core navigation; Phosphor Bold supplies the remaining actions. */
function appIcon(icon: Icon, name: string, weight: "bold" | "fill" = "bold"): Icon {
  const Component = forwardRef<SVGSVGElement, IconProps>((props, ref) => createElement(icon, {
    size: 20,
    "aria-hidden": props.alt || props["aria-label"] || props["aria-labelledby"] ? undefined : true,
    focusable: "false",
    ...props,
    weight,
    ...{ "data-app-icon": name, "data-icon-weight": weight },
    ref,
  }));
  Component.displayName = `${name}Icon`;
  return Component;
}

export const ImageIcon = appIcon(iconlyIcon("Image"), "Image");
export const ThreeDIcon = appIcon(PhosphorCube, "ThreeD");
export const VideoIcon = appIcon(iconlyIcon("Video"), "Video");
export const AudioIcon = appIcon(iconlyIcon("Voice"), "Audio");
export const WaveformIcon = appIcon(iconlyIcon("Voice"), "Waveform");
export const LibraryIcon = appIcon(iconlyIcon("Category"), "Library");
export const ReferenceLibraryIcon = appIcon(PhosphorBooks, "ReferenceLibrary");
export const PinIcon = appIcon(PhosphorPin, "Pin");
export const PaletteIcon = appIcon(PhosphorPalette, "Palette");
export const LocationIcon = appIcon(PhosphorLocation, "Location");
export const ElementIcon = appIcon(PhosphorShapes, "Element");
export const ProjectIcon = appIcon(iconlyIcon("Folder"), "Project");
export const SearchIcon = appIcon(iconlyIcon("Search"), "Search");
export const SettingsIcon = appIcon(iconlyIcon("Setting"), "Settings");
export const MenuIcon = appIcon(PhosphorMenu, "Menu");
export const PanelLeftIcon = appIcon(PhosphorPanelLeft, "PanelLeft");
export const RefreshIcon = appIcon(PhosphorRefresh, "Refresh");
export const UndoIcon = appIcon(PhosphorUndo, "Undo");
export const RedoIcon = appIcon(PhosphorRedo, "Redo");
export const ExpandIcon = appIcon(PhosphorExpand, "Expand");
export const HomeIcon = appIcon(iconlyIcon("Home"), "Home");
export const PlusIcon = appIcon(PhosphorPlus, "Plus");
export const MinusIcon = appIcon(PhosphorMinus, "Minus");
export const UploadIcon = appIcon(iconlyIcon("Upload"), "Upload");
export const DownloadIcon = appIcon(PhosphorDownload, "Download");
export const UserIcon = appIcon(PhosphorUser, "User");
export const OfflineIcon = appIcon(PhosphorOffline, "Offline");
export const SignOutIcon = appIcon(PhosphorSignOut, "SignOut");
export const TrashIcon = appIcon(PhosphorTrash, "Trash");
export const CheckIcon = appIcon(PhosphorCheck, "Check");
export const CircleHalfIcon = appIcon(PhosphorCircleHalf, "CircleHalf");
export const CircleNotchIcon = appIcon(PhosphorCircleNotch, "CircleNotch");
export const CheckCircleIcon = appIcon(PhosphorCheckCircle, "CheckCircle");
export const XCircleIcon = appIcon(PhosphorXCircle, "XCircle");
export const ReusableIcon = appIcon(PhosphorReusable, "Reusable");
export const ActivityIcon = appIcon(PhosphorActivity, "Activity");
export const TeamIcon = appIcon(PhosphorTeam, "Team");
export const CaretDownIcon = appIcon(PhosphorCaretDown, "CaretDown");
export const CaretUpIcon = appIcon(PhosphorCaretUp, "CaretUp");
export const CaretLeftIcon = appIcon(PhosphorCaretLeft, "CaretLeft");
export const CaretRightIcon = appIcon(PhosphorCaretRight, "CaretRight");
export const CaretUpDownIcon = appIcon(PhosphorCaretUpDown, "CaretUpDown");
export const MoreIcon = appIcon(PhosphorMore, "More");
export const MoreVerticalIcon = appIcon(PhosphorMoreVertical, "MoreVertical");
export const CloseIcon = appIcon(PhosphorClose, "Close");
export const SlidersIcon = appIcon(PhosphorSliders, "Sliders");
export const CreditCardIcon = appIcon(PhosphorCreditCard, "CreditCard");
export const CreditsIcon = appIcon(PhosphorCoins, "Credits", "fill");
export const WorkspacesIcon = appIcon(PhosphorWorkspaces, "Workspaces");
export const WarningIcon = appIcon(PhosphorWarning, "Warning");
export const GridIcon = appIcon(PhosphorGrid, "Grid");
export const ListIcon = appIcon(PhosphorList, "List");
export const TextIcon = appIcon(PhosphorText, "Text");
export const SparkleIcon = appIcon(PhosphorSparkle, "Sparkle", "fill");
export const HeartIcon = appIcon(PhosphorHeart, "Heart", "fill");
export const HeartOutlineIcon = appIcon(PhosphorHeart, "HeartOutline");
export const ArrowUpIcon = appIcon(PhosphorArrowUp, "ArrowUp");
export const ArrowRightIcon = appIcon(PhosphorArrowRight, "ArrowRight");
export const CropIcon = appIcon(PhosphorCrop, "Crop");
export const SunIcon = appIcon(PhosphorSun, "Sun");
export const PlayIcon = appIcon(PhosphorPlay, "Play", "fill");
export const PauseIcon = appIcon(PhosphorPause, "Pause", "fill");
export const PaperclipIcon = appIcon(PhosphorPaperclip, "Paperclip");
export const StackIcon = appIcon(PhosphorStack, "Stack");
export const CopyIcon = appIcon(PhosphorCopy, "Copy");

export const InfoIcon = appIcon(PhosphorInfo, "Info");
export const QuestionIcon = appIcon(PhosphorQuestion, "Question");

export const MegaphoneIcon = appIcon(PhosphorMegaphone, "Megaphone");

export const LinkIcon = appIcon(PhosphorLink, "Link");
export const LockIcon = appIcon(PhosphorLock, "Lock");

export const EyedropperIcon = appIcon(PhosphorEyedropper, "Eyedropper");

export const SaveIcon = appIcon(PhosphorSave, "Save");

export const ClockIcon = appIcon(iconlyIcon("TimeCircle"), "Clock");
export const MusicIcon = appIcon(PhosphorMusic, "Music");

export const VolumeIcon = appIcon(PhosphorSpeakerHigh, "Volume");
export const SpeedIcon = appIcon(PhosphorLightning, "Speed");
